<template>
    <div>
        <b-btn v-b-modal:productCoverModal variant="primary" class="mb-2">Edit Product Covers</b-btn>
        <!-- Folder Admin -->
        <b-container v-if="folders">

            <b-row>
                <!-- Folder Select -->
                <b-col cols="6" class="mx-0 px-0">
                    <b-card body-class="p-0">
                        <template #header>
                            Folders
                            <b-btn variant="link" class="p-0 m-0 float-right" @click="$bvModal.show('addFolderModal')">
                                <font-awesome-icon :icon="['fas', 'plus']" /> New
                            </b-btn>
                        </template>
                        <b-table ref="folder_table" :items="folders" selectable :select-mode="'single'" @row-selected="setSelectedFolder" :fields="folderTableFields" :busy="isLoading" selected-variant="primary" :style="{'max-height': MAX_HEIGHT + 'px'}">
                            <template #cell(actions)="data">
                                <b-btn size="sm" variant="danger" class="delete-btn" v-b-modal:deleteFolderModal @click="setFolderForDeletion(data.item)">
                                    <font-awesome-icon :icon="['fas', 'trash']" />
                                </b-btn>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
                <!-- Mapping Viewer -->
                <b-col v-if="selectedFolder" cols="6" class="mx-0 px-0">
                    <b-card body-class="p-0">
                        <template #header>
                            Folder Maps
                            <b-btn variant="link" class="p-0 m-0 float-right" @click="$bvModal.show('addMappingModal')">
                                <font-awesome-icon :icon="['fas', 'plus']" /> New
                            </b-btn>
                        </template>
                        <b-table :items="mappings" :fields="mappingTableFields" sticky-header :style="{'max-height': maxHeight()}" :busy="isLoading" striped tbody-tr-class="m-0 p-0" >
                            <template #cell(map_type)="data">
                                <span v-if="data.item.map_type == 'page'">Page</span>
                                <span v-if="data.item.map_type == 'product'">Product</span>
                            </template>
                            <template #cell(map_id)="data">
                                <span v-if="data.item.map_type == 'page'">
                                    <span v-for="(page, i) in pages" v-if="page.id == data.item.map_id">{{page.title}}</span>
                                </span>
                                <span v-if="data.item.map_type == 'product'">
                                    {{data.item.map_id}}
                                </span>
                            </template>
                            <template #cell(actions)="data">
                                <b-btn size="sm" variant="danger" class="delete-btn" v-b-modal:deleteMappingModal @click="setMapForDeletion(data.item)">
                                    <font-awesome-icon :icon="['fas', 'trash']" />
                                </b-btn>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="selectedFolder && folderImages && !isLoading">
                <!-- Folder Viewer -->
                <b-card class="w-100 mt-3" body-class="p-3">
                    <!-- Actions -->
                    <template #header>
                        <span>Images</span>
                        <b-btn variant="link" class="p-0 m-0 float-right" v-b-modal:addImageModal>
                            <font-awesome-icon :icon="['fas', 'plus']" /> New
                        </b-btn>
                    </template>

                    <!-- Items -->
                    <div class="d-flex justify-content-start flex-wrap">
                        <b-card v-for="(item, i) in folderImages"
                                :key="`img_${i}`"
                                style="width:150px; height: 150px;"
                                class="m-2"
                                body-class="p-0 m-0"
                        >
                            <a href="javascript:void(0)" @click.prevent="openViewer(item)">
<!--                            <template #header>{{item}}</template>-->
                                <b-card-img :src="imageUrl(item)" style="border: 2px solid black; border-radius: 5px"></b-card-img>
                            </a>

                            <b-btn variant="danger" class="px-2 py-1 delete-btn" size="sm" v-b-modal:deleteImageModal @click="setImageForDeletion(item, i)" style="position: absolute; top: -5px;right: -5px; border:1px solid black; border-radius:15px;">
                                <font-awesome-icon :icon="['fas', 'trash']" />
                            </b-btn>

                        </b-card>
                    </div>
                </b-card>
            </b-row>
        </b-container>


        <!-- Modals -->
        <b-modal id="productCoverModal" size="lg" hide-header ok-only>
            <ProductCoversAdmin />
        </b-modal>
        <b-modal id="contentViewer" size="lg" ok-only>
            <img :src="imageUrl(selectedImageSrc)" class="w-100 h-100">
        </b-modal>
        <b-modal id="addImageModal" @ok="addImage()">
            <template #modal-header>New Image</template>
            <b-form-file v-model="newImages" accept="image/*" :multiple="true"></b-form-file>
        </b-modal>
        <b-modal id="deleteImageModal" @ok="deleteImage()" size="lg">
            <template #modal-header>Delete {{ selectedImage }}?</template>
            <p>Are you sure you want to delete this image? This action cannot be undone.</p>
        </b-modal>
        <b-modal id="deleteFolderModal" @ok="deleteFolder()">
            <template #modal-header>Delete Folder?</template>
            <p>Are you sure you want to delete this folder? This action cannot be undone.</p>
        </b-modal>
        <b-modal id="addFolderModal" @ok="addNewFolder()">
            <template #modal-header>Add New Folder</template>
            <b-input-group prepend="Name">
                <b-input v-model="newFolder.name"></b-input>
            </b-input-group>
        </b-modal>
        <b-modal id="deleteMappingModal" @ok="deleteMapping()">
            <template #modal-header>Delete Map?</template>
            <p>Are you sure you want to delete this folder map? This action cannot be undone.</p>
        </b-modal>
        <b-modal id="addMappingModal" v-if="selectedFolder" @ok="addNewMapping()">
            <template #modal-header>Add Folder Mapping</template>
            <b-input-group prepend="Folder" :readonly="true" :disabled="true" class="mb-1">
                <b-input :value="selectedFolder.name" disabled></b-input>
            </b-input-group>
            <b-input-group prepend="Mapping Type"  class="mb-1">
                <b-select v-model="newMapping.map_type">
                    <b-select-option value="page">Page</b-select-option>
                    <b-select-option value="product">Product</b-select-option>
                </b-select>
            </b-input-group>

            <template v-if="newMapping.map_type == 'product'">
<!--                <b-input-group prepend="Sku:"  class="mb-1">-->
<!--                    <b-input type="text" placeholder="SW-00-SS-EN-V1" v-model="newMapping.map_id"></b-input>-->
<!--                </b-input-group>-->
<!--                <b-alert show variant="text" class="pb-0 mb-0">Find Sku:</b-alert>-->
<!--                <hr/>-->
                <b-input-group prepend="State:">
                <b-select v-model="mapProductState" @input="getStateProducts">
                    <b-select-option v-for="(state, i) in states" :value="state.state">{{state.fullState}}</b-select-option>
                </b-select>
                </b-input-group>
                <div class="loader" v-if="isFetchingProducts"></div>
                <multiselect id="sku"
                             v-if="stateProducts.length"
                             v-model="selectedMapProducts"
                             :options="stateProducts"
                             label="sku"
                             name="sku"
                             track-by="sku"
                             placeholder="Search Sku"
                             select-label=""
                             deselect-label=""
                             :searchable="true"
                             :multiple="true"
                             class=" w-100 d-inline-block"
                />
<!--                <b-button @click="addSelectedAsNew" v-if="selectedMapProducts.length">Add Selected</b-button>-->
            </template>
            <template v-if="newMapping.map_type == 'page'">
                <b-input-group prepend="Page:" class="mb-1">
                    <b-select id="new_page" v-model="newMapping.map_id">
                        <b-select-option v-for="(page, i) in pages" :value="page.id">{{page.title}}</b-select-option>
                    </b-select>
                </b-input-group>
            </template>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue'
import {mapState} from "vuex";
import states, {publicationStates} from "@/common/states";
import ProductCoversAdmin from "@/components/dashboard/storeadmin/ProductCoversAdmin.vue";
import {imageUrl} from "@/common/utils";

export default {
    name: "ImageAdmin",
    components: {ProductCoversAdmin, ProductCovers: ProductCoversAdmin},
    data: () => ({
        // Core Data
        folders: [],
        mappings: [],
        folderImages: [],
        // View Data
        MAX_HEIGHT: 300,
        selectedImageSrc: "",
        selectedMapProducts: [],
        mapProductState: null,
        stateProducts: [],
        isLoading: false,
        isFetchingProducts: false,
        states: publicationStates,
        newMapping: {map_type: null, map_id: null, folder_id: null},
        newFolder: {name: ""},
        newImages: [],
        selectedFolder: null,
        selectedMapping: null,
        selectedImage: null,
        folderTableFields: [
            { key: 'id', label: 'Id', sortable: true },
            { key: 'name', label: 'Name', sortable: true },
            { key: 'created_at', label: 'Created', sortable: true },
            { key: 'actions', label: ''}
        ],
        mappingTableFields: [
            // { key: 'id', label: 'Id' },
            { key: 'map_type', label: 'Category', sortable: true },
            { key: 'map_id', label: 'Type Id', sortable: true },
            { key: 'actions', label: ''}
        ],
    }),
    computed: {
        ...mapState({
            pages: state => state.stateData.pages,
        }),
        pageItems() {
            return this.folders.filter(x => x.type === 'page');
        },
        productItems() {
            return this.folders.filter(x => x.type === 'product');
        }
    },
    created() {
        this.getFolders();
    },
    methods: {
        async getStateProducts() {
            this.isFetchingProducts = true;
            if (!this.mapProductState) return;

            let response = await this.axios.get(`/home/${this.mapProductState}/`);
            this.isFetchingProducts = false;
            this.stateProducts = response.data.publications;
        },
        async getFolders() {
            this.isLoading = true;
            let response = await this.axios.get('/images/folders');
            this.isLoading = false;
            this.folders = response.data;
        },
        async addNewFolder() {
            let response = await this.axios.post('/images/folder', this.newFolder);
            this.newFolder = {name: ""};
            this.getFolders();
        },

        async deleteFolder() {
            if (!this.selectedFolder) return;

            let response = await this.axios.delete(`/images/folder/${this.selectedFolder.id}`);
            this.selectedFolder = null;
            this.getFolders();
        },
        async getFolderMappings() {
            if (!this.selectedFolder) return;

            let response = await this.axios.get(`/images/folder/${this.selectedFolder.id}/mappings`);
            this.mappings = response.data;
        },
        async addNewMapping() {
            // Handle multiple products
            if (this.newMapping.map_type === 'product') {
                for (let i = 0; i < this.selectedMapProducts.length; i++) {
                    let mapProduct = this.selectedMapProducts[i];
                    if (this.mappings.find(x => x.map_id === mapProduct.sku))
                        continue;

                    this.newMapping = {map_type: 'product', map_id: mapProduct.sku, folder_id: this.selectedFolder.id};
                    await this.axios.post('/images/mapping', this.newMapping);
                }
                this.getFolderMappings();
                return;
            }

            // Add new page mapping
            this.newMapping.folder_id = this.selectedFolder.id;
            let response = await this.axios.post('/images/mapping', this.newMapping);

            this.newMapping = {map_type: null, map_id: null, folder_id: null};
            this.getFolderMappings();
        },
        async deleteMapping() {
            let response = await this.axios.delete(`/images/mapping/${this.selectedMapping.id}`);
            this.getFolderMappings();
        },
        async getFolderImages() {
            if (!this.selectedFolder) return;

            let response = await this.axios.get(`/images/${this.selectedFolder.id}`);
            this.folderImages = response.data;
            if (this.folderImages.length)
                this.folderImages.sort((a,b) => a.localeCompare(b));
        },
        async deleteImage()
        {
            if (!this.selectedFolder || !this.selectedImage) return;

            let response = await this.axios.delete(`/images/${this.selectedFolder.id}`, {data: {image: this.selectedImage}});
            this.selectedImage = null;
            this.getFolderImages();
        },
        async addImage() {
            if (!this.selectedFolder || !this.newImages.length) return;

            let formData = new FormData();
            for (let i = 0; i < this.newImages.length; i++) {
                formData.append('images[]', this.newImages[i]);
            }

            let response = await this.axios.post(`/images/${this.selectedFolder.id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            this.newImages = [];
            this.getFolderImages();
        },
        async setSelectedFolder(items)
        {
            console.log(items);
            if (items.length > 0) {
                this.isLoading = true;
                this.selectedFolder = items[0];
                this.getFolderMappings();
                await this.getFolderImages();
                this.isLoading = false;
                return;
            }

            this.selectedFolder = null;
            this.mappings = [];
        },
        setFolderForDeletion(folder) {
            this.selectedFolder = folder;
        },
        setMapForDeletion(map) {
            this.selectedMapping = map;
        },
        setImageForDeletion(image) {
            this.selectedImage = image;
        },
        imageUrl: imageUrl,
        openViewer(imageRelativePath) {
            this.selectedImageSrc = imageRelativePath;
            this.$bvModal.show('contentViewer');
        },
        maxHeight() {
            return (this.$refs.folder_table.$el.offsetHeight <= this.MAX_HEIGHT) ? this.MAX_HEIGHT + 'px' : (this.$refs.folder_table.$el.offsetHeight) + 'px';
        }
    }

}
</script>


<style scoped lang="scss">
.delete-btn {
    opacity: 0.25;
    filter: grayscale(0.7);
}
.delete-btn:hover {
    opacity: 1;
    filter: grayscale(0);
}
</style>